import SnippetEditorial from './SnippetEditorial';

export default SnippetEditorial;
